<template lang="pug">
.layout.l-admin( :class='classes' )
  k-site-header( v-if='!noHeader' )
  .left-menu( :class=`{ 'menu-open': menuOpen }`)
    .main-menu( :class=`{ open: menuOpen }` )
      w-btn-icon.toggle( size='3q' @click.prevent='toggleMenu' )
        i-chevron-left.icon( v-if='menuOpen' )
        i-chevron-right.icon( v-else )
      .container
        .scroll( v-bar )
          .inner
            .content
              i-admin( title='Administration' )
              k-header Administration
              k-admin-menu
    .main.fixed( v-if='noScroll' )
      slot
    .main( v-else v-bar )
      .inner
        slot
  overlay
  sidebar( pos='left' )
  sidebar( pos='right' )
  modal
</template>

<script lang="js">
import KSiteHeader from '@/blocks/k-site-header'
import KHeader from '@/blocks/k-header'
import KAdminMenu from '@/blocks/k-admin-menu'
import WBtnIcon from '@/widgets/w-btn-icon'
import WpFooter from '@/components/wp-footer'
import Overlay from '@/components/overlay'
import Modal from '@/components/modal'
import Sidebar from '@/components/sidebar'
import IAdmin from 'icons/ApplicationCog'
import IChevronLeft from 'icons/ChevronLeft'
import IChevronRight from 'icons/ChevronRight'

export default {
  name: 'AdminLayout',
  mixins: [],
  components: {
    KSiteHeader,
    KHeader,
    KAdminMenu,
    WBtnIcon,
    WpFooter,
    Overlay,
    Modal,
    Sidebar,
    IAdmin,
    IChevronLeft,
    IChevronRight,
  },
  props: {
    noHeader: {
      type: Boolean,
      default: false
    },
    noFooter: {
      type: Boolean,
      default: false
    },
    noScroll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      unsubscribe: null,
      menuOpen: true,
    }
  },
  created() {
  },
  mounted() {},
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    }
  },
  beforeDestroy() {
    if ( this.unsubscribe ) this.unsubscribe()
  },
  computed: {
    menu() {
      return this.$store.state.menus.nav || []
    },
    site() {
      return {
        title: this.$store.state.site.title || 'My Blog',
        url: this.$store.state.site.url, // TODO: or?
        description: this.$store.state.site.description,
      }
    },
    classes() {
      return {
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/scss/breakpoint";

.l-admin {
  --c-bg: var(--c-bg-admin);
  --c-fg: var(--c-fg-admin);
  --c-bg-page: var(--c-bg);
  --bg-modal: var(--c-bg);
  --w-modal: 65%;
  --h-modal: 65%;
  --br-btn: 6px;
  --c-text: var(--c-fg-admin);
  background: var(--c-bg);
  color: var(--c-fg);
  .left-menu {
    display: flex;
    align-items: stretch;
    margin-top: var(--s-4xl);
    .main-menu {
      --pad-menu-item: var(--s-3q);
      --c-bg: white;
      position: relative;
      transition: width 400ms;
      width: var(--s-3xl);
      background: var(--c-bg);
      border-top-right-radius: 8px;
      /* box-shadow: 0 0 10px rgba(0,0,0,0.1); */
      /* height: 100%; */
      z-index: 2;
      &.open, &:hover {
        width: 16em;
      }
      > .toggle {
        position: absolute;
        top: var(--s-sm);
        right: calc( -1 * var(--s-base));
        z-index: 2;
        box-sizing: content-box;
        padding: var(--s-sm);
        background: rgba(255,255,255,0.01);
        .icon {
          border-radius: 200px;
          background: white;
          box-shadow: 0 1px 3px rgba(0,0,0,0.2);
        }
      }
      > .container {
        overflow: hidden;
        margin: 0;
        padding: 0;
        > .scroll {
          > .inner {
            > .content {
              width: 16em;
              .application-cog-icon {
                position: absolute;
                padding: var(--s-sm);
                font-size: var(--s-lg);
                top: 0;
                left: 0;
                svg {
                  width: var(--s-xl);
                  height: var(--s-xl);
                }
              }
            }
          }
        }
      }
      .k-header {
        margin-top: var(--s-3q);
      }
      .w-menu-item {
        .icon, .material-design-icon {
          margin-right: var(--s-3q);
        }
        &:hover, &:active {
          background: var(--c-fg);
        }
        &.current {
          background: var(--c-bg-admin);
          color: var(--c-bg);
        }
      }
    }
    .main {
      flex: 1;
      /* padding-left: var(--s-3xl); */
      &.fixed {
        > .k-page {
          overflow: hidden;
          > main {
            display: flex;
            flex-direction: column;
            height: 100%;
            padding-bottom: 0;
            padding-right: 0;
            .main-content {
              flex: 1;
              > .inner {
                padding-right: var(--s-lg);
                padding-bottom: var(--s-lg);
              }
            }
          }
        }
      }
    }
    &.menu-open {
      .main-menu {
        position: relative;
        height: unset;
      }
      .main {
        padding-left: 0;
      }
    }
  }
  .page {
    --fs-btn: var(--s-base);
    position: relative;
    height: calc( 100vh - var(--s-4xl));
    > .main {
      position: relative;
    }
    > .bottom-spacer {
      height: 15em;
      @include for-mobile {
        height: 2em;
      }
    }
    .actions {
      display: flex;
      justify-content: flex-end;
      > * {
        margin-left: var(--s-sm);
      }
      > .w-btn {
        padding: var(--s-sm) var(--s-3q);
        background: rgba(0,0,0,0.05);
        &.icon {
          background: transparent;
        }
        .icon {
          margin-right: var(--s-xs);
        }
        &-icon .icon {
          margin-right: 0;
        }
      }
      &.footer-actions {
        margin: var(--m-footer-actions, var(--s-sm));
      }
    }
    section {
      --c-bg: #fdfeff;
      --c-loader: var(--c-fg);
      --c-input-border: rgba(0,0,0,0.1);
      --c-input-border-active: rgba(0,0,0,0.25);
      position: relative;
      background: var(--c-bg);
      color: var(--c-fg);
      margin-bottom: var(--s-lg);
      border: 1px solid white;
      /* box-shadow: 0 2px 8px rgba(0,0,0,0.1); */
      padding: var(--pad-section, var(--s-base));
      border-radius: var(--br-section, 8px);
      max-width: unset;
      &:last-child {
        margin-bottom: 0;
      }
      > * {
        color: var(--c-fg);
      }
      > .header {
        position: relative;
        margin-bottom: var(--s-sm);
        > .title {
          font-size: var(--s-lg);
          /* margin-bottom: var(--s-base); */
        }
      }
      .k-item.body, .k-item > .body {
        > .title {
          display: flex;
          align-items: center;
          padding: var(--s-3q) var(--s-lg);
          border-radius: var(--br-section-title,
                             var(--br-section, 4px));
          /* font-size: var(--s-lg); */
          transition: all 250ms;
          > .label {
            flex: 1;
            text-align: left;
            line-height: 1.3em;
            padding: 0;
          }
          > .text {
            flex: 1;
            text-align: left;
            line-height: 1.7em;
            padding: 0;
          }
          .info {
            display: flex;
            .tag {
              display: block;
              padding: 2px var(--s-3q);
              margin: 0 0 0 var(--s-xs);
              text-align: center;
              font-size: var(--s-3q);
              background: rgba(0,0,0,0.1);
              box-shadow:inset 0 0 10px rgba(0,0,0,0.08);
              border-radius: 4px;
              &.length {
                min-width: 5em;
                padding: 2px;
                color: var(--c-bg);
                background-color: var(--c-fg);
              }
            }
          }
          .w-btn-icon:first-child {
            margin-left: calc( -1 * var(--s-sm));
          }
        }
        > .info {
          position: relative;
          transition: 250ms all;
          opacity: 0;
          height: auto;
          max-height: 0;
          padding: var(--pad-item-info, 0 var(--s-xl));
          display: flex;
          flex: 1;
          align-items: center;
          --glow-hover: none;
          --glow-active: none;
          --glow-white: none;
          --glow-svg-hover: none;
          --glow-svg-active: none;
          --glow-svg-white: none;
          .attribute {
            color: var(--c-fg);
            line-height: 1.5em;
            padding-right: var(--s-xs);
            .icon {
              font-size: var(--s-lg);
            }
            &:hover, &:focus {
              background: rgba(0,0,0,0.08);
              /* color: var(--c-fg); */
              text-shadow: none;
            }
          }
          .actions {
            margin-top: 0;
            /* flex: 1; */
            align-items: center;
            .w-btn-icon {
              padding: var(--s-xs);
              border-radius: 4px;
              &:hover, &:focus {
                background: var(--c-fg);
                color: var(--c-bg);
                * {
                  color: var(--c-bg);
                }
              }
            }
          }
        }
        &.denied {
          display: flex;
          align-items: flex-end;
          .icon {
            margin-right: var(--s-sm);
          }
          span.text {
            line-height: 1.2em;
          }
        }
        .content {
          position: relative;
          display: grid;
          grid-template-columns: auto auto;
          padding: var(--s-base);
          border-bottom: 1px solid rgba(0,0,0,0.08);
          margin-bottom: var(--s-base);
          .key, .value {
            padding: var(--s-xs) var(--s-sm);
          }
          .key {
            font-weight: bold;
          }
        }
        > .info {
          display: flex;
          /* flex: 1; */
          align-items: flex-end;
          transition: 400ms;
          .tag {
            padding: var(--s-xs) var(--s-3q);
            background: rgba(0,0,0,0.1);
            box-shadow:inset 0 0 10px rgba(0,0,0,0.08);
            border-radius: 4px;
            margin: var(--s-xs) var(--s-xs) 0 0;
            display: flex;
            align-items: flex-end;
            .icon {
              svg {
                width: var(--s-base);
                height: var(--s-base);
              }
              margin-right: var(--s-xs);
            }
            .span {
              line-height: 1.2em;
            }
          }
          .collections {
            position: relative;
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            .title {
              width: 100%;
              text-align: left
            }
          }
        }
      }
      .k-item {
        &:hover, &.hover, &:focus, &.focus {
          &.body, > .body {
            background: rgba(0,0,0,0.05);
          }
          border-radius: 4px;
          /* padding-bottom: var(--s-sm); */
          > .title, > .body > .title, > .title *, > .body > .title * {
            background: var(--c-fg);
            color: var(--c-bg);
            text-shadow: none;
            > .label, .text, .icon, .icon *, .tag {
              color: var(--c-bg);
            }
            .tag {
              background: rgba(255,255,255,0.1);
              box-shadow:inset 0 0 10px rgba(255,255,255,0.08);
            }
          }
          > .info, > .body > .info {
            opacity: 1;
            max-height: unset;
            padding: var(--pad-item-info-active, var(--s-xs) var(--s-xl));
          }
        }
      }
      .actions {
        justify-content: flex-end;
        margin-top: var(--s-base);
        > .w-btn {
          background: rgba(0,0,0,0.05);
          &:hover, &.hover, &:focus, &.focus {
            background: var(--c-fg);
            color: var(--c-bg);
            * {
              color: var(--c-bg);
            }
          }
        }
      }
    }
    main {
      box-shadow: none;
      > .actions, > .main-content > .inner > .actions {
        > .w-btn {
          /* background: rgba(255,255,255,0.3); */
          background: transparent;
          margin: 0;
          &:hover, &:focus, &.hover, &.focus {
            background: rgba(255,255,255,0.6);
          }
        }
      }
    }
    main, main > .title {
      > .actions {
        &.header-actions {
          position: absolute;
          top: var(--s-xs);
          right: var(--s-3q);
          margin-top: 0;
          > .w-btn {
            padding: var(--s-sm);
            color: white;
            background: transparent;
            margin-left: 0;
            &:last-child {
              margin-right: var(--s-sm);
            }
            &:hover, &:focus, &.hover, &.focus {
              background: rgba(255,255,255,0.4);
              color: var(--c-fg);
            }
            .icon {
              margin: 0;
            }
          }
        }
      }
    }
  }
  .modal {
    --c-close-button: var(--c-fg);
    border-radius: 16px;
    &.fullscreen {
      border-radius: 0;
    }
  }
  .k-card {
    --c-bg: white;
  }
}
</style>
